exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuickLinks_wrapper__Bae9Z{display:-webkit-box;display:flex;flex-wrap:wrap}@media only screen and (max-width:719px){.QuickLinks_wrapper__Bae9Z{-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}}.QuickLinks_link__2ReN4{margin:10px 0;display:-webkit-box;display:flex}@media only screen and (max-width:719px){.QuickLinks_link__2ReN4:last-child{margin-bottom:0}}.QuickLinks_link__2ReN4 svg{flex-shrink:0}.QuickLinks_link__2ReN4 .QuickLinks_linkText__2-jU7{font-size:14px;line-height:20px;font-weight:400;margin:0 30px 0 10px;color:#333;cursor:pointer}.QuickLinks_link__2ReN4 .QuickLinks_linkText__2-jU7:hover{color:#42b4e6}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"wrapper": "QuickLinks_wrapper__Bae9Z",
	"link": "QuickLinks_link__2ReN4",
	"linkText": "QuickLinks_linkText__2-jU7"
};